module.exports = __webpack_public_path__ + "static/media/bannerYT.fb95b4b2.png";